import type { FC } from "react";
import type { OrganicDateFilters } from "src/dashboards/organicMedia/components/Tabs/FacebookContentReport";
import PlatformAdsReport from "../platformReport/PlatformAdsReport";

const TikTokAdsReport: FC<{ dateFilters: OrganicDateFilters }> = ({ dateFilters }) => (
  <PlatformAdsReport platform="tiktok_ads" dateFilters={dateFilters} />
);

export default TikTokAdsReport;
